import { useEffect } from 'react';

const TAWK_PROPERTY_ID = '6a34717eacfa9d1d3e924adf';
const TAWK_WIDGET_ID = '1jredmmbo';

export function useTawkTo(enabled = true) {
  useEffect(() => {
    if (!enabled) {
      // Hide widget if disabled
      if (window.Tawk_API && window.Tawk_API.hideWidget) {
        window.Tawk_API.hideWidget();
      }
      return;
    }

    // Check if already loaded
    if (window.Tawk_API && window.Tawk_LoadStart) {
      // Show widget
      if (window.Tawk_API.showWidget) {
        window.Tawk_API.showWidget();
      }
      return;
    }

    // Load Tawk.to script
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://embed.tawk.to/${TAWK_PROPERTY_ID}/${TAWK_WIDGET_ID}`;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');

    document.head.appendChild(script);

    return () => {
      // Hide widget on unmount
      if (window.Tawk_API && window.Tawk_API.hideWidget) {
        window.Tawk_API.hideWidget();
      }
    };
  }, [enabled]);
}
